import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

const HeadTags = (props) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{props.title}</title>
      <meta name="description" content={props.desc} />
      <link rel="canonical" href="http://localhost:8000/" />
      <link rel="icon" href="favicon.ico" />
    </Helmet>
  );
};

// Prop validation
HeadTags.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};

export default HeadTags;
